import { referralsFolder } from 'constants/Referrals';
import styles from './AvatarOnBeachTowel.module.css';
import { AvatarWithAccessory } from './AvatarWithAccessory';

interface AvatarOnBeachTowelProps {
  /** The optional avatarUrl. An undefined avatarUrl does not imply the avatar is not present,
   * as our data structure for a user allows their avatar to be empty. Empty avatars will be
   * replaced by a randomised avatar
   */
  avatarUrl?: string;
  /* If true, this avatar will render as a button that shows the invite modal when clicked */
  isEmptySlot?: boolean;
  towelIndex: '1' | '2' | '3';
  inactive?: boolean;
}

export const AvatarOnBeachTowel = ({
  avatarUrl,
  isEmptySlot,
  towelIndex,
  inactive,
}: AvatarOnBeachTowelProps) => {
  return (
    <AvatarWithAccessory
      avatarUrl={avatarUrl}
      isEmptySlot={isEmptySlot}
      accessorySrc={`${referralsFolder}/beach-towel-icon-${towelIndex}.svg`}
      accessoryClassName={styles.towelAccessory}
      inactive={inactive}
    />
  );
};
